<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <!-- <div  class="div-query-banner"  >
          <a-form-item label="投诉人姓名">
            <j-input  v-model="queryParam.userName"   />
          </a-form-item>
          <a-form-item label="被投诉人姓名">
            <j-input   v-model="queryParam.targetUserName"    />
          </a-form-item>
          <a-button  class="query-banner-btn" type="primary" @click="searchQuery" icon="search">查询</a-button>
          <a-button  class="query-banner-btn" type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">重置</a-button>
        </div> -->
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleAdd()" type="primary" icon="plus">新增</a-button>
      <!-- <a-button type="primary" icon="import" @click="openSelectUser()">批量增加员工</a-button> -->
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-button type="primary" icon="import" @click="batchAddLeader(selectedRowKeys)">批量修改领导</a-button>
      </a-dropdown>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择
        <a style="font-weight: 600">{{ selectedRowKeys.length }}</a
        >项
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
      </div>

      <a-table
        ref="table"
        size="middle"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{ fixed: true, selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        @change="handleTableChange"
      >
        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">编辑</a>
        </span>
        <div slot="status" slot-scope="text, record">
          <p  v-if="record.status == 1" class="stateOpenColor">激活</p>
          <p v-else class="stateDisableColor">禁用</p>
        </div>
      </a-table>
    </div>
    <select-user-modal ref="selectUserModal" :onlySelectOne="true" @selectChoosed="selectOK"></select-user-modal>
    <select-lead-modal ref="SelectLeadModal" :onlySelectOne="true" @selectChoosed="selectleadOK"></select-lead-modal>

    <busDailyStaff-modal ref="modalForm" @ok="modalFormOk"></busDailyStaff-modal>
  </a-card>
</template>

<script>
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import BusDailyStaffModal from './modules/BusDailyStaffModal'
import SelectLeadModal from './modules/SelectLeadModal'
import SelectUserModal from './modules/SelectUserModal'
import { getAction, postAction } from '@/api/manage'

export default {
  name: 'BusDailyStaffList',
  mixins: [JeecgListMixin],
  components: {
    BusDailyStaffModal,SelectLeadModal,SelectUserModal
  },
  data() {
    return {
      description: '工作人员表管理页面',
      // 表头
      leadStr: '',
      columns: [
        {
          title: '#',
          dataIndex: '',
          key: 'rowIndex',
          width: 60,
          align: 'center',
          customRender: function (t, r, index) {
            return parseInt(index) + 1
          },
        },
        {
          title: '员工名称',
          align: 'center',
          dataIndex: 'employeeName',
        },
        {
          title: '领导名称',
          align: 'center',
          dataIndex: 'leadName',
        },
        {
          title: '总分',
          align: 'center',
          dataIndex: 'score',
        },
        {
          title: '备注',
          align: 'center',
          dataIndex: 'remark',
        },
        {
          title: '状态',
          align: 'center',
          dataIndex: 'status',
          scopedSlots: { customRender: 'status' },
          // customRender: function (t, r, index) {
          //   if (r.status === 1) {
          //     return '激活'
          //   } else {
          //     return '禁用'
          //   }
          // },
        },
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          scopedSlots: { customRender: 'action' },
        },
      ],
      url: {
        list: '/dailyproject/busDailyStaff/getList',
        delete: '/dailyproject/busDailyStaff/delete',
        deleteBatch: '/dailyproject/busDailyStaff/deleteBatch',
        exportXlsUrl: '/dailyproject/busDailyStaff/exportXls',
        importExcelUrl: 'dailyproject/busDailyStaff/importExcel',
      },
      dictOptions: {},
      recordChoose: {},
    }
  },
  computed: {
    importExcelUrl: function () {
      return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`
    },
  },
  methods: {
    initDictConfig() {},
    selectOK(selectData) {
      let str = ''
      if (selectData.length > 1) {
        str = selectData.reduce((sun, element) => {
          if (sun.username) {
            return sun.username + ',' + element.username
          }
          return sun + ',' + element.username
        })
      } else {
        str = selectData[0].username
      }
      let param = {
        staffs: str,
      }
      getAction('/dailyproject/busDailyStaff/addList', param).then((res) => {
        if (res.success) {
          this.$message.success(res.message)
          this.loadData()
        } else {
          this.$message.error(res.message)
        }
      })
    },
    selectleadOK(selectData) {
      if (selectData.length === 1) {
        let parm = {
          ids: this.leadStr,
          leadId: selectData[0].username,
        }
        postAction('/dailyproject/busDailyStaff/addLead', parm).then((res) => {
          console.log(res)
          if (res.success) {
            this.$message.success(res.message)
            this.loadData()
          } else {
            this.$message.error(res.message)
          }
        })
      }
    },
    openSelectUser() {
      this.$refs.selectUserModal.add()
    },
    batchAddLeader(selectedRowKeys) {
      this.$refs.SelectLeadModal.add()
      let str = selectedRowKeys.reduce((sun, element) => {
        return sun + ',' + element
      })
      this.leadStr = str
    },
  },
}
</script>
<style lang="less" scoped>
@import '~@assets/less/common.less';
.div-query-banner{
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  & >*:nth-child(n){
    width:300px;
  }
  &>*:nth-child(n+2){
    margin-left: 12px;
  }
  &>.query-banner-btn:nth-child(n){
    width:100px
  }
}
.stateOpenColor {
  color: rgb(6, 124, 2);
  margin-top: 15px;
}
.stateDisableColor {
  color: rgb(182, 6, 6);
  margin-top: 15px;
}
</style>